<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GjmK8Q/tc-custom/9780740792069.jpg?1707448904377" alt="This image is the cover for the book Idiots in Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Idiots in Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Here's best-selling humor writer Leland Gregory's sixth collection about everyday idiots-and this time they're in love! Readers are guaranteed to feel better about their own romantic misadventures after reading these jaw-dropping, hilarious tales.</p><p>Many people do crazy things in the name of love, but some people take things way too far. From failed seductions to botched proposals, from disturbing displays of affection to misguided marriages, <i>Idiots in Love</i> chronicles the stupid things falling in love (or falling out of it) can drive people to do:</p><p>* A female Coca-Cola employee became engaged to a Pepsi employee, and Coke demanded that she break it off, persuade her fiance to leave Pepsi, or resign from Coca-Cola. She refused and was terminated, but she later won a $600,000 settlement from the company.</p><p>* A woman in Hardwick, Georgia, divorced her husband on the grounds that he "stayed home too much and was too affectionate."</p><p>* A couple started divorce proceedings after 90 minutes of marriage.</p><p>* A Norwegian woman hid a ring in her boyfriend's porridge to propose marriage to him, but he accidentally ate the ring. Fortunately, he accepted the proposal anyway.</p><p>* In Whitesville, Delaware, it is illegal for a woman to propose to a man.</p><p>* A European survey revealed that one in nine people admit to sending themselves Valentine's Day cards.</p><p>Once again, Leland Gregory finds the absolute best and funniest anecdotes and one-liners that will have readers rolling with laughter at the amorous antics of idiots in love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leland Gregory
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?006fb6fe